import { GridColDef } from "@mui/x-data-grid";

export const columns: GridColDef[] = [
    { field: 'actorName', headerName: 'Name', flex: 1.5 },
    { field: 'sessionRole', headerName: 'Role', flex: 0.7 },
    { field: 'totalSessions', headerName: 'Total Sessions', flex: 0.7 },
    { field: 'sessionsAttended', headerName: 'Present', flex: 0.6 },
    { field: 'sessionsLate', headerName: 'Late', flex: 0.5 },
    { field: 'sessionsSick', headerName: 'Sick', flex: 0.5 },
    { field: 'sessionsExcused', headerName: 'Excused', flex: 0.5 },
    { field: 'sessionsAbsent', headerName: 'Absent', flex: 0.5 },
    { field: 'totalHours', headerName: 'Hours', flex: 0.6, valueFormatter: (params) => `${params.value}h` },
    { field: 'attendancePercentage', headerName: 'Attendance %', flex: 0.7, valueFormatter: (params) => `${params.value}%` }
];
